import { removeDocumentInUserContext } from '../../firebase/document/documentSagas';
import { RESIDENTS_PREFERENCES } from '../../../shared/collection/collectionConstants';

export default class RemoveResidentFromFavoritesUseCase {
  static *remove(failureCallback, action) {
    yield* removeDocumentInUserContext(RESIDENTS_PREFERENCES, failureCallback, action);
  }
}
